import React, { useEffect, useState } from "react";
import "./NewPreviewUI.css";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import NewPreviewSmallCard from "./NewPreviewNewCard";
import { useDispatch, useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import axios from "axios";
import EditSearchModal from "./EditSearchModal";
import { setSelectedContentAI } from "../../redux/slices/selectedContentAI";

const NewPreviewLeftCustomisationData = ({
  editSearch,
  seteditSearch,
  setshowmodel,
  setshowPreviewList,
  setUseTemplateSelected,
  setGetExtendedResult,
  customisationId,
  setCustomisationId,

  listofcustomisations,
}) => {
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const selectedTemplatePreview = useSelector(
    (state) => state?.preview?.previewTemplateObject
  );
  const previewObject = useSelector((state) => state?.preview?.previewObject);
  const dispatch = useDispatch();
  const [totalNumberofPages, settotalNumberofPages] = useState(1);
  const [selectedPage, setSelectedPage] = useState(1);
  const [showEditTemplateModal, setShowEditTemplateModal] = useState(false);
  const editMeetingObject = useSelector(
    (state) => state?.editmeeting?.editmeetingobject
  );

  useEffect(() => {
    // this will go inside every meetingroom
    const meetingObj = JSON.parse(localStorage.getItem("MeetingObject"));
    const selectedIndex = meetingObj?.customProperties?.selectionIndex;
    if (selectedIndex !== null && selectedIndex !== undefined) {
      setSelectedCardIndex(selectedIndex);
    }
  }, [selectedCardIndex]);

  useEffect(() => {
    if (listofcustomisations != null) {
      settotalNumberofPages(
        Math.round(listofcustomisations.length / 3) == 0
          ? 1
          : Math.round(listofcustomisations.length / 3)
      );
    }
  }, [listofcustomisations, selectedPage]);
  const handleSelect = (index) => {
    setSelectedCardIndex(index);
  };

  const handleMeetingCreate = () => {
    if (previewObject == null) {
      enqueueSnackbar("Error: You have not selected any customisation", {
        preventDuplicate: true,
        autoHideDuration: 3000,
        variant: "error",
      });
    } else {
      const storedMeetingObject = localStorage.getItem("meetingObject");
      if (storedMeetingObject) {
        // Parse the stored string into an object
        const parsedMeetingObject = JSON.parse(storedMeetingObject);

        // Ensure customProperties is initialized
        if (!parsedMeetingObject.customProperties) {
          parsedMeetingObject.customProperties = {};
        }

        // Dispatch the values to setSelectedContentAI
        const contentAI = {
          customisationId,
          selectionIndex: previewObject.selectedIndex,
          showTitle: previewObject.showTitle,
          styleTop: previewObject.styleTop,
          styleBottom: previewObject.styleBottom,
          styleLeft: previewObject.styleLeft,
          styleRight: previewObject.styleRight,
          styleZoom: previewObject.styleZoom,
          displayProperty: previewObject?.displayProperty,
        };

        dispatch(setSelectedContentAI({ contentAI }));

        parsedMeetingObject.customProperties = {
          ...parsedMeetingObject.customProperties,
          ...contentAI,
        };

        localStorage.setItem(
          "meetingObject",
          JSON.stringify(parsedMeetingObject)
        );
      }

      setCustomisationId(null);
    }
  };

  return (
    <>
      <div className="newPreviewLeftCustomisationList">
        <div className="newPreviewLeftCustomisationListHeader">
          <div className="newPreviewLeftCustomisationListHeaderTitle">
            Signage Preview
          </div>
          <div className="newPreviewLeftCustomisationListHeaderText">
            Quick view and edit the signage
          </div>
        </div>
        <div className="newPreviewLeftCustomisationListSearchContainer">
          <div className="newPreviewLeftCustomisationListSearchItems">
            <div
              className="newPreviewLeftCustomisationRefreshList"
              onClick={() => {
                setGetExtendedResult(true);
              }}
              onMouseEnter={() => {}}
            >
              <RotateRightIcon style={{ fontSize: "medium" }} />
            </div>
            {/* <div
              className="newPreviewLeftCustomisationEditSearch"
              onClick={() => {
                seteditSearch(true);
              }}
            >
              Edit Search
            </div> */}
          </div>
        </div>

        <div className="newPreviewLeftCustomisationListContainer">
          {listofcustomisations != null ? (
            listofcustomisations.map((data, index) => {
              const startIndex = (selectedPage - 1) * 3;
              const endIndex = startIndex + 3;
              if (index >= startIndex && index < endIndex) {
                return (
                  <NewPreviewSmallCard
                    key={index}
                    data={data}
                    index={index}
                    onSelect={handleSelect}
                    selected={index === selectedCardIndex}
                  />
                );
              } else {
                return null;
              }
            })
          ) : (
            <></>
          )}
        </div>
        <div className="newPreviewLeftpaginationContainer">
          <div
            className="newPreviewLeftpaginationLeftButton"
            onClick={() => {
              setSelectedPage(
                selectedPage - 1 < 1 ? selectedPage : selectedPage - 1
              );
            }}
          >
            <ChevronLeftIcon />
          </div>
          <div className="newPreviewLeftpaginationPageNumber">
            {selectedPage + "/" + totalNumberofPages}
          </div>
          <div
            className="newPreviewLeftpaginationRightButton"
            onClick={() => {
              setSelectedPage(
                selectedPage + 1 > totalNumberofPages
                  ? selectedPage
                  : selectedPage + 1
              );
            }}
          >
            <ChevronRightIcon />
          </div>
        </div>
        <div className="newPreviewLeftCustomisationSaveButtonContainer">
          <span
            className="newPreviewLeftCustomisationSaveButton"
            onClick={handleMeetingCreate}
          >
            Select
          </span>
        </div>
      </div>
      {/* {editSearch && (
        <EditSearchModal
          editSearch={editSearch}
          seteditSearch={seteditSearch}
        />
      )} */}
    </>
  );
};

export default NewPreviewLeftCustomisationData;
